import { render } from "./ProfileAppointmentsTable.vue?vue&type=template&id=5a1cce11"
import script from "./ProfileAppointmentsTable.vue?vue&type=script&lang=js"
export * from "./ProfileAppointmentsTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__